"use client";

import { useEffect, useRef } from 'react';
import { signOut, useSession } from 'next-auth/react';
import { useSidebar } from '@/app/context/SidebarContext';
import LogoutIcon from '../../../../../public/images/icons/logout.svg';

const UserMenu = () => {
  const { data: session } = useSession();
  const { isCollapsed, userMenuOpen, toggleUserMenu, closeUserMenu } = useSidebar();
  const menuRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        closeUserMenu();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [userMenuOpen, closeUserMenu]);

  // Escape closes the dropdown (WCAG 2.1.1)
  useEffect(() => {
    if (!userMenuOpen) return undefined;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeUserMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [userMenuOpen, closeUserMenu]);

  if (!session?.user) return null;

  const name = session.user.name || '';
  const email = session.user.email || '';
  const parts = name.trim().split(' ');
  const initials = `${parts[0]?.[0]?.toUpperCase() || ''}${parts.length > 1 ? parts[parts.length - 1][0]?.toUpperCase() : ''}`;

  const handleLogout = () => {
    signOut();
  };

  return (
    <div className="sidebar-user" ref={menuRef}>
      {/* Dropdown (slides up from avatar) */}
      <div className={`sidebar-user-dropdown ${userMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-user-info">
          <div className="sidebar-user-name">{name}</div>
          <div className="sidebar-user-email">{email}</div>
        </div>
        <button className="sidebar-user-logout" onClick={handleLogout}>
          <LogoutIcon className="icon-sm" />
          <span>Sign out</span>
        </button>
      </div>

      {/* Avatar trigger */}
      <button
        className="sidebar-user-trigger"
        onClick={toggleUserMenu}
        aria-haspopup="true"
        aria-expanded={userMenuOpen}
        {...(isCollapsed ? {
          'data-bs-toggle': 'tooltip',
          'data-bs-placement': 'right',
          title: name,
        } : {})}
      >
        <div className="sidebar-user-avatar">
          {initials}
        </div>
        {!isCollapsed && (
          <div className="sidebar-user-label">
            <span className="sidebar-user-label-name">{name}</span>
          </div>
        )}
      </button>
    </div>
  );
};

export default UserMenu;
